import {
  formatEnumValue,
  getEnumOptions,
  type EnumValueSource,
} from "@/modules/sqdc/helper/SQDCEnumValueHelper";

type TranslateFunction = (key: string) => string;

export const SQDC_REPAIR_WINDOW_PLAN_DATE_VALUE = "PLAN_DATE";

export function getSQDCRepairWindowOptions(
  enumValues: readonly EnumValueSource[] | null | undefined,
  locale: string,
  translate: TranslateFunction,
) {
  return [
    ...getEnumOptions(enumValues, locale, translate),
    {
      label: translate("components.issueModal.planDate"),
      value: SQDC_REPAIR_WINDOW_PLAN_DATE_VALUE,
    },
  ];
}

export function isSQDCRepairWindowPlanDateValue(value: unknown) {
  return value === SQDC_REPAIR_WINDOW_PLAN_DATE_VALUE;
}

export function formatSQDCRepairWindowEnumValue(
  enumValues: readonly EnumValueSource[] | null | undefined,
  value: string,
  locale: string,
  translate: TranslateFunction,
) {
  return isSQDCRepairWindowPlanDateValue(value)
    ? translate("components.issueModal.planDate")
    : formatEnumValue(enumValues, value, locale, translate);
}
